/**
import { generatedFormattedDate } from './dateAndTime';
 * General function for creating a formatted date from day month and year
 * @param {Number} day
 * @param {Number} month
 * @param {Number} year
 */
export const generatedFormattedDate = (
  currentDay,
  currentMonth,
  currentYear
) => {
  const year =
    currentYear < 1000
      ? currentYear < 100
        ? currentYear < 10
          ? "000" + currentYear
          : "00" + currentYear
        : "0" + currentYear
      : "" + currentYear;
  const month = currentMonth < 10 ? "0" + currentMonth : "" + currentMonth;
  const day = currentDay < 10 ? "0" + currentDay : "" + currentDay;
  return year + "-" + month + "-" + day;
};

// eslint-disable-next-line
export const generatedFormattedTime = (hr, min, sec) => {
  const hour = hr < 10 ? "0" + hr : "" + hr;
  const minute = min < 10 ? "0" + min : "" + min;
  // const second = sec < 10 ? '0' + sec : '' + sec

  return hour + ":" + minute;
};
